import {
    Site,
    SuperbetRouteConfig,
} from '@superbet-group/web.types';
import { omit as _omit } from 'lodash';
import { Route } from 'vue-router';

import { Link } from '@app/router/constants/Link';
import { RouteName } from '@app/router/constants/RouteName';
import { currentSite } from '@app/utils/domainHelpers';
import {
    checkIntroPageRedirection,
    defaultLayout,
    getSportPageClasses,
} from '@app/router/utils';
import {
    gamesTitle,
    Title,
} from '@app/router/constants/Title';
import { AnalyticsScreenNames } from '@app/utils/analyticsScreenNames';
import { homePage } from '@pages/HomePage';
import { prematchPage } from '@pages/SportsPage';
import { getFederationComponent } from '@src/federations/getFederationComponent';

const homePageRouteConfig: SuperbetRouteConfig = {
    path: Link.App.Home,
    name: RouteName.App.Home,
    components: {
        ...defaultLayout,
        ...homePage,
    },
    meta: {
        title: Title.App.Home,
        headerTitle: 'home',
        layoutClass: 'home-page',
        superAnalytics: {
            pageName: AnalyticsScreenNames.home,
        },
        mobileHeaderConfig: {
            isHome: true,
        },
    },
    beforeEnter(to, from, next) {
        checkIntroPageRedirection(to, next);
    },
};

const _sportHomepageRouteConfig: SuperbetRouteConfig = {
    path: Link.App.Home,
    name: RouteName.App.Home,
    components: {
        ...defaultLayout,
        ...prematchPage,
    },
    meta: {
        title: Title.Sport.Favourites,
        layoutClass: getSportPageClasses,
        superAnalytics: {
            pageName: AnalyticsScreenNames.preMatchSportOffer,
        },
    },
    beforeEnter(to, from, next) {
        checkIntroPageRedirection(to, next);
    },
};

// The setup method in MyCasinoContainer makes it so that this will always be redirected to the
// casino, even though it seems here like the path should be just /, because the child routes
// within casino wouldn't work otherwise.
const casinoHomepageRouteConfig = {
    path: Link.App.Home,
    name: RouteName.App.Home,
    components: {
        ..._omit(defaultLayout, 'mobileSubnav'),
        content: getFederationComponent(() => import('gaming/GamesPage')),
    },
    meta: {
        title: gamesTitle,
        layoutClass: 'games',
    },
    beforeEnter(to: Route, from: any, next: AnyFunction) {
        checkIntroPageRedirection(to, next);
    },
};

const countryHomepageRoutes: Record<Site, SuperbetRouteConfig> = {
    [Site.SuperbetRo]: homePageRouteConfig,
    [Site.SuperbetPl]: homePageRouteConfig,
    [Site.SuperbetCom]: homePageRouteConfig,
    [Site.SuperbetBr]: homePageRouteConfig,
    [Site.SuperbetRs]: homePageRouteConfig,
    [Site.SuperbetBg]: homePageRouteConfig,
    [Site.NapoleonGames]: casinoHomepageRouteConfig,
    [Site.NapoleonSports]: homePageRouteConfig,
    [Site.NapoleonCasino]: casinoHomepageRouteConfig,
    [Site.NapoleonDice]: casinoHomepageRouteConfig,
    [Site.SuperSocialBr]: homePageRouteConfig,
    [Site.NapoleonGamesRo]: casinoHomepageRouteConfig,
};

export const homepageRouteConfig = countryHomepageRoutes[currentSite];
